import React, { Component } from 'react';
import { connect } from 'react-redux'
import AlertMessageSupervisor from './AlertMessageSupervisor.jsx';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { ALERTS_SHOWED, USER_STATE } from '../../constants.js';
import ManualCallReprogrammed from '../Alerts/ManualCallReprogrammed.jsx';
import CancelNoAvailableState from '../Alerts/CancelNoAvailableState.jsx';
import AlertMessageVolume from '../Alerts/AlertMessageVolume.jsx';
import { manualCall, messageToStateMachine } from '../../redux/actions/A_messages_to_SM';
import { ACTIONS_FROM_SM } from "../../constants";
class AlertsContainerMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrayAlertsTop: [],
      arrayAlerts: [],
      messageAlert: null,
    }
    this.sharedData = new  SingletonSharedData();
    this.message = 0;
    this.arrayNormal = [];
    this.alertsActions = {
      [ALERTS_SHOWED.INSERT_CALL_ALERT]: () => this.insertAlert("manualCallAlert", () => <ManualCallReprogrammed onCancel={this.cancelManualCallReprogramed} />),
      [ALERTS_SHOWED.REMOVE_CALL_ALERT]: () => this.removeAlert("manualCallAlert"),
      [ALERTS_SHOWED.INSERT_NO_AVAILABLE_ALERT]: () => this.insertAlert("noAvailableAlert", (message) => <CancelNoAvailableState message={message} onCancel={(idNoAvailable) => this.cancelNoAvailableState(idNoAvailable)} />),
      [USER_STATE.NO_AVAILABLE]: () => this.removeAlert("noAvailableAlert"),
      [USER_STATE.CALL_OUT]: () => this.removeAlert("manualCallAlert"),
      [ALERTS_SHOWED.INSERT_VOLUME_ALERT]: () => this.insertAlert("volumeAlert", () => <AlertMessageVolume hideNotification={this.removeAlertVolume} />),
      
    };
  }
  
  removeAlertVolume =()=> {
    this.removeAlert("volumeAlert");
  }
  cancelManualCallReprogramed = () => {
    var data = {
      CamId: 0, CallKey: "", Phone: "",
      Data: "", ExistsCallout: 0, CallMode: 0
    };
    this.props.manualCall(data);
    this.removeAlert("manualCallAlert");
  }
  cancelNoAvailableState(idNoAvailable) {
    let obj = {
      "action": "notReady", "username": this.sharedData.getUserData().Login,
      "userID": this.sharedData.getParameters().UserID, "notReadyId": 0, "Sender": 2
    };
    this.props.messageToStateMachine(JSON.stringify(obj));
    this.removeAlert("noAvailableAlert");
  }
  insertAlert(tag, component) {
    let arrayAlertsTop = this.state.arrayAlertsTop;
    let arrayfilter = arrayAlertsTop.filter((item) => { return item.tag === tag });
    if (!arrayfilter.length) {
      arrayAlertsTop.push({ tag: tag, drawComponent: component, });
    }
    this.setState({ arrayAlertsTop: arrayAlertsTop });
  }
  removeAlert(tag) {
    let arrayAlertsTop = this.state.arrayAlertsTop;
    arrayAlertsTop = arrayAlertsTop.filter((item) => item.tag !== tag)
    this.setState({ arrayAlertsTop: arrayAlertsTop });
  }
  openChat = () => {
    this.setState({ arrayAlerts: [] });
  }

  shouldComponentUpdate(nextProps, nextState) {
    
    return  nextProps.actionAlert ||
    nextProps.stateMachineActions.actionType !== ACTIONS_FROM_SM.NO_ACTION
    || this.state.arrayAlertsTop.length !== nextState.arrayAlertsTop.length ;

  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.stateMachineActions.message && nextProps.stateMachineActions.actionType
      && nextProps.stateMachineActions.actionType !== "NO_AVAILABLE_INFO") {
      this.deleteAlert(this.message - 1);
      var currentTime = new Date().toLocaleTimeString();
      let messageToList = { type: 1, user: nextProps.stateMachineActions.supervisor, text: nextProps.stateMachineActions.message, hour: currentTime };
      this.sharedData.setObjectChat(messageToList, nextProps.stateMachineActions.supervisor);
      this.sharedData.setNewNotificationChat(nextProps.stateMachineActions.supervisor);
      if (!this.sharedData.getChatWindowOpen()) {
        this.arrayNormal.splice(0, 0, {
          index: this.message++,
          drawComponent: (index) => <AlertMessageSupervisor
            messageFrom={nextProps.stateMachineActions.supervisor}
            message={nextProps.stateMachineActions.message}
            index={index}
            canResponse={index === (this.message - 1)}
            deleteAlert={(index) => this.deleteAlert(index)}
            onOpenChat={this.openChat} />
        });
        this.setState({ arrayAlerts: this.arrayNormal });
      }
    }
    if ((this.state.messageAlert && this.state.messageAlert.action === "notReadyScheduled")
      && (nextProps.userState && nextProps.userState.currentState === USER_STATE.AGENT_READY)) {
      this.removeAlert("noAvailableAlert");
    }
    this.setState({ messageAlert: nextProps.alertMessage })
    if (this.alertsActions[nextProps.actionAlert]) {
      this.alertsActions[nextProps.actionAlert]();
    }
    if (this.alertsActions[nextProps.userState.currentState]) {
      this.alertsActions[nextProps.userState.currentState]();
    }
  }
  
  validateTypeAlert(tag){
    return tag === "onPreviewModeAlert" ? "PreviewMode" : "";
  }

  deleteAlert(index) {
    this.arrayNormal = this.arrayNormal.filter((item) => item.index !== index);
    this.setState({ arrayAlerts: this.arrayNormal });
  }
  
  render() {
    return (
      <div>
        {this.state.arrayAlertsTop.map((item) =>
          <div className={"messageAlertsContainer " + (this.validateTypeAlert(item.tag))}>
            <div key={"alert" + item.tag}>
              {item.drawComponent(this.state.messageAlert)}
            </div>
          </div>)}
        {this.state.arrayAlerts.map((item) =>
          <div className={"messageAlertsContainer " + (this.validateTypeAlert(item.tag))}>
            <div key={"alert" + item.index}>
              {item.drawComponent(item.index)}
            </div>
          </div>)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { stateMachineActions: state.stateMachineActions, userState: state.userState }
}

function mapDispatchToProps(dispatch) {
  return ({
    manualCall: (data) => { dispatch(manualCall(data)); },
    messageToStateMachine: (message) => { dispatch(messageToStateMachine(message)); }
  });
}

export default (AlertsContainerMessage) = connect(mapStateToProps,mapDispatchToProps)(AlertsContainerMessage);



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertsContainerMessage.jsx